// extracted by mini-css-extract-plugin
export var card = "address-card-module--card--xucWI";
export var cardActionBox = "address-card-module--card-action-box--yySun";
export var cardContent = "address-card-module--card-content--fxDr5";
export var cardTitle = "address-card-module--card-title--bfoKk";
export var clickable = "address-card-module--clickable--b8pcL";
export var selected = "address-card-module--selected--AI+8L";